
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMobileOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'ABOUT', id: 'who-we-are' },
    { label: 'SERVICES', id: 'services' },
    { label: 'WHY US', id: 'why-choose-us' },
    { label: 'PORTFOLIO', id: 'gallery' },
    { label: 'CONTACT', id: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#1A1A1A] shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Top utility bar */}
      <div className={`transition-all duration-300 overflow-hidden ${isScrolled ? 'h-0' : 'h-9'}`}>
        <div className="bg-[#E8740C] w-full">
          <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-9">
            <div className="flex items-center gap-6">
              <a href="tel:5308068659" className="flex items-center gap-1.5 text-white text-xs font-medium cursor-pointer hover:text-white/80 transition-colors">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-xs"></i></div>
                <span>530-806-8659</span>
              </a>
              <span className="text-white/60 text-xs hidden sm:inline">|</span>
              <span className="text-white text-xs font-medium hidden sm:inline">24/7 Emergency Service Available</span>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-white text-xs font-medium hidden md:inline">Licensed &amp; Insured</span>
              <span className="text-white/60 text-xs hidden md:inline">|</span>
              <span className="text-white text-xs font-medium hidden md:inline">Serving All of California</span>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 py-3 flex items-center justify-between max-w-7xl mx-auto w-full">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img
            src="https://static.wixstatic.com/media/163680_ea15eaa1c2a94dfb89bebd1cd017303d~mv2.png/v1/fill/w_130,h_129,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/New-Generation-Welding-Logo-08.png"
            alt="New Generation Welding Logo - Yuba County Welding Contractor"
            title="New Generation Welding & Fabrication"
            className="h-14 w-auto"
          />
        </div>

        <div className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
              className="text-white text-xs font-semibold tracking-widest hover:text-[#E8740C] transition-colors cursor-pointer font-heading"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#request-quote"
            onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
            className="bg-[#E8740C] text-white text-xs font-bold tracking-wider px-5 py-2.5 rounded-md hover:bg-[#d16a0b] transition-colors cursor-pointer whitespace-nowrap font-heading"
          >
            GET A QUOTE
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#1A1A1A] border-t border-white/10 px-6 py-4">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
              className="block py-3 text-white text-sm font-semibold tracking-wider hover:text-[#E8740C] transition-colors cursor-pointer font-heading"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#request-quote"
            onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
            className="block mt-3 bg-[#E8740C] text-white text-sm font-bold tracking-wider px-5 py-3 rounded-md text-center cursor-pointer whitespace-nowrap font-heading"
          >
            GET A QUOTE
          </a>
        </div>
      )}
    </nav>
  );
}
